import React from 'react';

const StatsCard = ({ title, value, iconClass, color, trend }) => {
  return (
    <div className="stats-card">
      <div className="stats-card-content">
        <div className="stats-card-info">
          <h3>{title}</h3>
          <p>{value}</p>
          {trend && (
            <div className={`trend ${trend.isPositive ? 'positive' : 'negative'}`}>
              <span>{trend.isPositive ? '+' : ''}{trend.value}%</span>
              <span>from last month</span>
            </div>
          )}
        </div>
        <div className="stats-card-icon" style={{ background: color }}>
          <i className={`fa ${iconClass}`}></i>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;